module.exports = "/_next/static/images/ship-3cb3d81d73489864c374b136c2248f9e.svg";